import React from 'react';

import HowDoesItWorkStyles from './HowDoesItWork.css';

import HowItWorksImage1 from '../images/how-it-works-1.png';
import HowItWorksImage2 from '../images/how-it-works-2.png';
import HowItWorksImage3 from '../images/how-it-works-3.png';
import HowItWorksImage4 from '../images/how-it-works-4.png';

export default class HowDoesItWork extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            definitons: {}
        }
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.definitons !== undefined) {

            this.setState({
                definitons: nextProps.definitons,
            });

        }

    }

  render() {

    return (

        <div className="how-does-it-work">

            <div className="main-container">

                <h2>{(this.state.definitons["hdiw-title"] || "How does it work")}</h2>
                <h3>{(this.state.definitons["hdiw-subhead"] || "Our frames are well suited for framing posters, prints and photographs")}</h3>

                <div className="process clearfix">

                    <div className="step">
                        <div className="img" style={{
                            backgroundImage: `url('${HowItWorksImage1}')`
                        }} />
                        <h4>
                            <label>1</label>
                            {(this.state.definitons["hdiw-feature-1-title"] || "Measurment")}
                        </h4>
                        <p>
                            {(this.state.definitons["hdiw-feature-1-description"] || "Measure your artwork from edge to edge and provide your dimensions or select from one of our popular sizes")}
                        </p>
                    </div>

                    <div className="step">
                        <div className="img" style={{
                            backgroundImage: `url('${HowItWorksImage2}')`
                        }} />
                        <h4>
                            <label>2</label>
                            {(this.state.definitons["hdiw-feature-2-title"] || "Build & Customize")}
                        </h4>
                        <p>
                            {(this.state.definitons["hdiw-feature-2-description"] || "Use our simple visual editor to customize your perfect picture and review options and pricing as you edit")}
                        </p>
                    </div>

                    <div className="step">
                        <div className="img" style={{
                            backgroundImage: `url('${HowItWorksImage3}')`
                        }} />
                        <h4>
                            <label>3</label>
                            {(this.state.definitons["hdiw-feature-3-title"] || "Crafting")}
                        </h4>
                        <p>
                            {(this.state.definitons["hdiw-feature-3-description"] || "Once your order is completed our master craftsman will get crafting your custom frame right away")}
                        </p>
                    </div>


                    <div className="step">
                        <div className="img" style={{
                            backgroundImage: `url('${HowItWorksImage4}')`
                        }} />
                        <h4>
                            <label>4</label>
                            {(this.state.definitons["hdiw-feature-4-title"] || "Delivery")}
                        </h4>
                        <p>
                            {(this.state.definitons["hdiw-feature-4-description"] || "Your order is complete and delivered within 3-5 business days along with simple mounting instructions")}
                        </p>
                    </div>

                </div>

            </div>

        </div>

    );

  }

}



// WEBPACK FOOTER //
// ./src/components/HowDoesItWork.js